import MyComputed from "./myComputed";

const RolePlugin  = {
  // install( Vue, options) {
  install( Vue) {
    Vue.mixin({
      computed: {
        ...MyComputed
      },
      // mounted() {
      //   console.log("My Role Plugin mounted")
      // },
      methods: {
        currentRoles() {
          if ( this.$store
              && this.$store.state
              && this.$store.state.auth
              && this.$store.state.auth.user
              && this.$store.state.auth.user.roles ) {
            return this.$store.state.auth.user.roles;
          }
          return undefined;
        },
        checkRole( roles ) {
          // console.log("this.checkRole  roles:");
          // console.log(JSON.stringify(roles, undefined, 2));
          // console.log(`this.currentRoles`);
          // console.log(this.currentRoles);
          // console.log("this.selectedCompetitionId");
          // console.log(this.selectedCompetitionId);
          // console.log(currentUser());
          let returndata = this.verifyRoles( roles, this.currentRoles(), this.selectedCompetitionId );
          // console.log(`returndata: ${returndata}`);
          return returndata;
        },
        verifyRole ( role, currentRoles, competition_id) {
            // console.log("VERIFYROLE");
            // console.log("role");
            // console.log(JSON.stringify(role, undefined, 2));
            // console.log("currentRoles");
            // console.log(JSON.stringify(currentRoles, undefined, 2));
            // console.log("competition_id");
            // console.log(competition_id);
            // console.log(`typeof role:  ${typeof role}    isArray: ${Array.isArray(role)}`)
      
            if ( role && currentRoles ) {
              if ( typeof role === "string" ) {
                if ( currentRoles.some( r => { return r.name === role; })) {
                  return true;
                }
              } else {
                if ( typeof role === "object" ) {
                  // console.log("HABLE1");
                  // console.log(role);
                  // console.log(role.verify_competition);
                  if ( role.verify_competition==true ) {
                    // console.log("HABLE2");
                    // console.log(currentRoles.some( r => { return r.name === role.name && (r.competition_id === competition_id || r.competition_id === 0 || r.competition_id == null); }));
                    if ( currentRoles.some( r => { return r.name === role.name && (r.competition_id === competition_id || r.competition_id === 0 || r.competition_id == null); })) {
                      // console.log("ACCESS OK1")
                      return true;
                    }
                  } else {
                    if ( currentRoles.some( r => { return r.name === role.name })) {
                      // console.log("ACCESS OK2")
                      return true;
                    }
                  }
                }
              }
            }
          // console.log("ACCESS NOT OK")
          return false;
        },
        verifyRoles (rolesToCheck, currentRoles, competition_id) {
          let checkOk = false
          if ( rolesToCheck && currentRoles ) {
            // console.log("rolesToCheck");
            // console.log(JSON.stringify(rolesToCheck, undefined, 2));
            // console.log("currentRoles");
            // console.log(JSON.stringify(currentRoles, undefined, 2));
            // console.log("competition_id");
            // console.log(competition_id);
            // console.log(`typeof rolesToCheck:  ${typeof rolesToCheck}    isArray: ${Array.isArray(rolesToCheck)}`)
      
            if ( typeof rolesToCheck === "string" ) {
              checkOk = this.verifyRole( rolesToCheck, currentRoles, competition_id );
            } else {
              if ( Array.isArray( rolesToCheck )) {
                for ( let i = 0; i < rolesToCheck.length; i++ ) {
                  // console.log("============ FOR LOOP - "+ i);
                  if ( this.verifyRole(rolesToCheck[i], currentRoles, competition_id ) ) {
      // console.log("ACCESS OK3 - break for loop and continue...");
                    checkOk = true;
                    break;
                  }
                }
              } else {
                if ( typeof rolesToCheck === "object" ) {
                  checkOk = this.verifyRole( rolesToCheck, currentRoles, competition_id );
                }
              }
            }
          }
          return checkOk;
        }
      }
    })
  }
}

export default RolePlugin;
